angular.module('dpw.components').component('dpwAddInInstallation', {
    templateUrl: 'dpw-add-in-installation.component.html',
    controllerAs: 'ctrl',
    bindings: {
        actionEnabledInProd: '<',
        appKey: '<',
        application: '<',
        botInfo: '<',
        botEnvs: '<',
        disabledMsgInProd: '<',
        canManipulateApp: '<',
        onInstall: '&',
        onUninstall: '&',
        onUpdateBotInfo: '&',
        onRefreshStatus: '&'
    },
    controller: [ function () {}]
});
